<div class="row justify-content-md-center">
  <h3>Gestione Profili <small>Parco {{parkName}} </small> </h3>

</div>

<div class="row justify-content-md-center">

  <div class="col col-lg-2">
  </div>
  <div class="col col-lg-8">
    <table class="table table-striped">
      <thead>
      <tr class="tableProfile">
        <th scope="col">#</th>
        <th scope="col">Amministratore</th>
        <th scope="col">Data Creazione</th>
        <th scope="col">Rimuovi/Riattiva</th>

      </tr>
      </thead>
      <tbody>
      <tr class="tableProfile" *ngFor="let uad of userAdministrateParksList">
        <th scope="row">{{uad.id}}</th>
        <td>{{uad.usr_name_complete}}</td>
        <td>{{uad.created_at |date: 'dd/MM/yyyy'}}</td>
        <td>
          <button class="btn btn-danger" [hidden]="uad.closed_at" (click)="deleteUserAdministrateParks(uad.id,uad.usr_name_complete)"><i class="fas fa-ban"></i></button>
          <button class="btn btn-secondary" [hidden]="!uad.closed_at" (click)="restoreUserAdministrateParks(uad.id,uad.usr_name_complete)"><i class="fas fa-history"></i></button>
        </td>
      </tr>

      </tbody>
    </table>
  </div>
  <div class="col col-lg-2">
  </div>
</div>


<div class="row justify-content-md-center">
  <div class="col col-lg-2">
  </div>
  <div class="col  col-lg-8">

    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon14">Cerca utente</span>
      </div>
      <input type="text" class="form-control" placeholder="Cerca per cognome, CF o email ..."
             (input)="onUserNameChanged(userInput.value)" #userInput
             aria-label="Cerca..." aria-describedby="basic-addon1">
      &nbsp;<button class="btn btn-primary" (click)="addUserAdministrateParks()" [disabled]="!user">Aggiungi</button>
    </div>

    <ul class="user-search-list list-group mb-3" #listGroup [hidden]="mydataz.users.length == 0">
      <li class="list-group-item" style="  font-size: 10px; padding: 10px;" *ngFor="let userItem of mydataz.users"
        [class.active]="user === userItem" (click)="userSelected(userItem)">{{userItem.name}} {{userItem.surname}}
        ({{userItem.email}})</li>
    </ul>

  </div>
  <div class="col col-lg-2">
  </div>
</div>

